<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <!-- <farm-info :id="$route.params.farmId"/> -->
      <div class="page-title">
        <div class="d-flex justify-center align-center">
          <h2 class="text-capitalize">
            {{ product.name ? product.name : "name" }}
          </h2>
          <p style="margin: 0 0 0 10px;">
            #{{ product.productNumber ? product.productNumber : "product" }}
          </p>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="dialog = true"> {{$t('organizationNtrInfo.addStock')}} </v-btn>
        <v-btn
          color="primary"
          class="ml-2"
          :to="{
            name: 'CreateOrder',
            params: {
              farmId: $route.params.farmId,
              productId: $route.params.productId,
            },
          }"
        >
          {{$t('organizationNtrInfo.createAOrder')}}
        </v-btn>
      </div>
      <div>
        <v-row no-gutters class="">
          <v-col>
            <v-card
              class="mx-auto rounded-lg mr-auto"
              max-height="150"
              elevation="0"
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="inline">
                    <v-list-item-avatar
                      class="mb-5 float-left"
                      size="50"
                      color="#E5F8F1"
                    >
                      <img
                        src="/img/organisation_ntr/Delivered.png"
                        alt=""
                        style="height: 25px; width: 25px"
                      />
                    </v-list-item-avatar>
                    <div class="mt-2">
                      <v-list-item-title
                        class="text-h5 subtitle-2 font-weight-black mb-1"
                      >
                        {{ product.stockQty }} {{ product.stockUom }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="font-weight-medium"
                        >{{$t('organizationNtrInfo.totalStocks')}}</v-list-item-subtitle
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="mx-auto  rounded-lg ml-2"
              max-height="150"
              elevation="0"
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="inline">
                    <v-list-item-avatar
                      class="mb-5 float-left"
                      size="50"
                      color="#E5F8F1"
                    >
                      <img
                        src="/img/organisation_ntr/Order.png"
                        alt=""
                        style="height: 25px; width: 25px"
                      />
                    </v-list-item-avatar>
                    <div class="mt-2">
                      <v-list-item-title
                        class="text-h5 subtitle-2 font-weight-black mb-1"
                      >
                        {{ totalOrderCount }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="font-weight-medium"
                        >{{$t('organizationNtrInfo.orders')}}</v-list-item-subtitle
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col cols="">
            <v-card
              class="mx-auto rounded-lg ml-2"
              max-height="150"
              elevation="0"
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="inline">
                    <v-list-item-avatar
                      class="mb-5 float-left"
                      size="50"
                      color="#E5F8F1"
                    >
                      <img
                        src="/img/organisation_ntr/Pending_Order.png"
                        alt=""
                        style="height: 25px; width: 25px"
                      />
                    </v-list-item-avatar>
                    <div class="mt-2">
                      <v-list-item-title
                        class="text-h5 subtitle-2 font-weight-black mb-1"
                      >
                        {{ pending }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="font-weight-medium">
                        {{$t('organizationNtrInfo.totalPending')}}</v-list-item-subtitle
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="mx-auto  rounded-lg ml-2"
              max-height="150"
              elevation="0"
            >
              <v-list-item>
                <v-list-item-content>
                  <div class="inline">
                    <v-list-item-avatar
                      class="mb-5 float-left"
                      size="50"
                      color="#E5F8F1"
                    >
                      <img
                        src="/img/organisation_ntr/Delivered.png"
                        alt=""
                        style="height: 25px; width: 25px"
                      />
                    </v-list-item-avatar>
                    <div class="mt-2">
                      <v-list-item-title
                        class="text-h5 subtitle-2 font-weight-black mb-1"
                      >
                        {{ deliver }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="font-weight-medium"
                        >{{$t('organizationNtrInfo.totalDelivered')}}</v-list-item-subtitle
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div class="mt-2">
        <v-card elevation="10" class="px-5">
          <v-card-text>
            <template>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  :placeholder="$t('search')"
                  dense
                  v-model="search"
                  @click:append="searchUsers"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-tooltip top color="black">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" dense>
            mdi-information-outline
          </v-icon>
        </template>
        <span>{{$t('searchByRecepientNameOrderIdRecepientId')}}.</span>
      </v-tooltip>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchUsers"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} {{$t('of')}} {{ totalOrders }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                  <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  left
                  :min-width="417"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> mdi-cog-outline </v-icon>
                    </v-btn>
                  </template>

                  <v-card width="417">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            $t("customization")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t("recordsPerPage") }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider
                            v-model="itemsPerPageSlider"
                            :tick-labels="itemsPerPageOptions"
                            :max="3"
                            step="1"
                            ticks="always"
                            tick-size="4"
                          ></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col
                            class="mt-n9"
                            cols="6"
                            v-for="header in headers"
                            :key="header.value"
                          >
                            <v-checkbox
                              v-model="selectedHeaders"
                              :label="header.text"
                              color="primary"
                              :value="header.text"
                              hide-details
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>

                        <v-btn
                          outlined
                          color="primary"
                          @click="menu = false"
                          width="190"
                        >
                          {{ $t("restoreDefault") }}
                        </v-btn>
                        <v-btn
                          color="primary"
                          width="190"
                          @click="resetTableStructure"
                        >
                          {{ $t("apply") }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportToPDF"
                >
                  <v-img src="/icons/download.svg"></v-img>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="printPDF"
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
                <!-- <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn> -->
              </div>
            </template>
            <!-- <div class="mb-2">
                       <h2>Orders</h2>
                    </div> -->
            <div ref="document">
              <v-data-table
                :headers="tableHeaders"
                :items="items"
                v-model="selected"
                show-select
                :loading="loading"
                :items-per-page="5"
                :loading-text="$t('organizationNtrInfo.loadingOrdersPleaseWait')"
                :hide-default-footer="true"
                :footer-props="{
                  'items-per-page-options': [5, 10, 25],
                  'show-first-last-page': true,
                  'show-current-page': true,
                  'items-per-page-text': 'Orders per page',
                }"
                :options.sync="tableOptions"
                :server-items-length="totalOrders"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-if="items.length > 0" v-slot:body="{ items }">
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item.orderNumber"
                      @mouseover="selectItem(item)"
                      @mouseleave="unSelectItem()"
                      @click="
                        $router.push({
                          name: 'OrderDetails',
                          params: { 
                            orderId: item.orderNumber,
                            farmId: $route.params.farmId,
                            productId: $route.params.productId, 
                          },
                        })
                      "
                      style="position: relative; width: 0; height: 0"
                    >
                    <td>
                      <v-checkbox
                        multiple
                        v-model="selected"
                        :value="item"
                        style="margin: 0px; padding: 0px"
                        hide-details
                        v-on:click.stop=""
                      />
                    </td>
                    <template v-for="h in tableHeaders">
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'recipientName'"
                      >{{ `${item.recipientName}` }}</td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'orderNumber'">{{ `#${item.orderNumber}` }}</td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'recipientId'">{{ `#${item.recipientId}` }}</td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'transactionId'">{{ item.transactionId }}</td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'productQty'">
                        {{ item.productQty }} {{ item.productQtyUom }}
                      </td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'totalPrice'">
                        {{ item.totalPrice }} ({{ item.currency }})
                      </td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'date'">
                        {{ item.createdAt | formatDate }}
                      </td>
                      <td :key="h.value"
                          class="text-center"
                          v-if="h.value == 'status'">
                        <v-btn
                          v-if="item.status == 'confirmed' || item.status == 'delivered'"
                          x-small
                          rounded
                          color="green2"
                          min-width="120"
                          depressed
                          class="green--text"
                          height="34"
                          style="border: 1px solid green !important;"
                        >
                          {{ item.status }}
                        </v-btn>
                        <v-btn
                          v-else
                          x-small
                          rounded
                          min-width="120"
                          color="gray2"
                          depressed
                          height="34"
                          class="black--text"
                          style="border: 1px solid black !important;"
                        >
                          {{ item.status }}
                        </v-btn>
                      </td>
                      </template>
                      <!-- <td
                  style="position: absolute; right: 10px; top: 4px"
                  v-if="item === selectedItem"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        fab
                        v-bind="attrs"
                        v-on="on"
                        :to="({name: 'OrderDetails', params: { orderId: item.orderNumber }})"
                      >
                        <v-icon>mdi-dots-horizontal</v-icon></v-btn
                      >
                    </template>
                    <span>More Details</span>
                  </v-tooltip>
                </td> -->
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <!-- <div class="float-right mt-5 mb-5">
            <v-btn
              width="146"
              class="mr-2"
              outlined
              color="primary"
              disabled
              >Export</v-btn
            >
            <v-btn width="146" type="submit" color="primary">Print</v-btn>
          </div> -->
    </v-container>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="addStock"
        >
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title>{{$t('organizationNtrInfo.addStock')}} </v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  type="number"
                  v-model="stocks"
                  outlined
                  :placeholder="$t('organizationNtrInfo.quantity')"
                  dense
                  :rules="productRules.stocks"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  :items="perUni"
                  :placeholder="$t('organizationNtrInfo.selectUnit')"
                  outlined
                  dense
                  v-model="stockUom"
                  :rules="productRules.stockUom"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-auto mb-4" style="width: 95%"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="px-8 mb-4" color="primary" outlined @click="dialog = false">
              {{$t('cancel')}}
            </v-btn>
            <v-btn class="px-8 mb-4" color="primary" type="submit"> {{$t('inseminatorStatisticsInfo.addStock')}}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/core/Breadcrumb";
import NtrService from "@/_services/NtrService";
import loadingMixin from "@/mixins/LoadingMixin";
import { productRules } from "@/validations/ProductRules.js";
// import FarmInfo from "./FarmInfo.vue"
import html2pdf from "html2pdf.js";
import printJS from "print-js";
export default {
  components: {
    breadcrumb: Breadcrumb,
    // FarmInfo
  },
  watch: {
    tableOptions: {
      handler() {
        this.getProducts();
      },
      deep: true,
    },
  },
  async mounted() {
     this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },

  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },

    searchUsers() {
      console.log("ser", this.search);
      if (this.search == "") return;
      this.tableOptions.page = 1;
      this.getProducts();
    },
    resetSearchOnEmpty() {
      if (this.search != "") return;
      this.tableOptions.page = 1;
      this.getProducts();
    },
    async exportToPDF() {
      console.log('first')
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "SingleProducts.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },

    async printPDF() {
      let opt = {
        margin: 1,
        filename: "SingleProducts.pdf",
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(this.$refs.document)
        .toCanvas()
        .outputPdf("blob", "SingleProducts.pdf");
      let file = new File([worker], "SingleProducts.pdf", {
        type: "application/pdf",
      });
      console.log(file);
      var pdfUrl = await URL.createObjectURL(file);
      console.log(pdfUrl);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getProducts() {
      // this.startLoading();
      this.loading = true;
      NtrService.getProductOrders(
        this.$route.params.productId,
        this.tableOptions,
        this.search
      )
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.items = res.data.orderHistory.rows;
            this.totalOrders = res.data.orderHistory.total_rows;
            if (this.totalOrders < 1) {
            this.oldSelected = this.selectedHeaders;
            this.selectedHeaders = this.noRecordHeader;
          } else {
            if (this.oldSelected.length > 1)
              this.selectedHeaders = this.oldSelected;
            else {
              this.selectedHeaders = this.allSelectedHeaders;
              this.oldSelected = [];
            }
          }

            this.currentrows = res.data.orderHistory.num_rows;

          this.resetTableStructure();
            this.pageCount = Math.ceil(
              this.totalOrders / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalOrders / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - res.data.orderHistory.num_rows);
            this.deliver = res.data.orderHistory.deliveredOrderCount;
            this.pending = res.data.orderHistory.pendingOrderCount;
            this.totalOrderCount = res.data.orderHistory.totalOrderCount;
            this.product = res.data.orderHistory.product;
            this.loading = false;
            // this.stopLoading();
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          // this.stopLoading();
        });
    },
    addStock() {
      if (!this.$refs.form.validate()) return;
      let data = {
        productNumber: this.$route.params.productId,
        stockQty: this.stocks,
        stockUom: this.stockUom,
      };
      console.log(data);
      NtrService.addStock(data)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.getProducts();
            this.dialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getProducts();
    },
     resetTableStructure() {
      // this.startLoading();
      this.loading = true;
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      // this.stopLoading();
      this.loading = false;
    },
  },
  data() {
    return {
      from: 0,
      to: 0,
      totalPages: 1,
      menu: false,
      itemsPerPageSlider: 1,
      itemsPerPageOptions: [5, 10, 25, 50],
      selectedHeaders: [],
      tableHeaders: [],
      oldSelected: [],
       allSelectedHeaders: [
        this.$t('organizationNtrInfo.recepientName'),
        this.$t('organizationNtrInfo.orderID'),
        this.$t('organizationNtrInfo.recipientID'),
        this.$t('organizationNtrInfo.transactionID'),
        this.$t('organizationNtrInfo.quantity'),
        this.$t('organizationNtrInfo.cost'),
        this.$t('date'),
        this.$t('status')
      ],
      noRecordHeader: [
       this.$t('organizationNtrInfo.recepientName'),
        this.$t('organizationNtrInfo.orderID'),
        this.$t('organizationNtrInfo.recipientID'),
        this.$t('organizationNtrInfo.transactionID'),
        this.$t('organizationNtrInfo.quantity'),
        this.$t('organizationNtrInfo.cost'),
        this.$t('date'),
        this.$t('status')
      ],
      deliver: "",
      pending: "",
      product: {},
      dialog: false,
      productRules,
      valid: true,
      stocks: "",
      totalOrderCount: "",
      currentrows: 0,
      search: "",
      selected: [],
      items: [],
      numbers: [1],
      totalOrders: 0,
      selectedItem: false,
      isActive: true,
      loading: false,
      length: 0,
      pageCount: 0,
      tableOptions: {},
      perUni: ["kg"],
      stockUom: "",
      headers: [
        {
          text: this.$t('organizationNtrInfo.recepientName'),
          value: "recipientName",
          align: "start",
        },
        {
          text: this.$t('organizationNtrInfo.orderID'),
          align: "start",
          value: "orderNumber",
        },
        {
          text: this.$t('organizationNtrInfo.recipientID'),
          value: "recipientId",
          align: "center",
        },
        {
          text: this.$t('organizationNtrInfo.transactionID'),
          value: "transactionId",
          align: "center",
        },
        {
          text: this.$t('organizationNtrInfo.quantity'),
          value: "productQty",
          align: "center",
        },
        {
          text: this.$t('organizationNtrInfo.cost'),
          value: "totalPrice",
          align: "center",
        },
        {
          text: this.$t('date'),
          value: "date",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t('status'),
          value: "status",
          align: "center",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('organizationNTR'),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "ProductList" },
        },
        {
          text: this.$t('organizationNtrInfo.farmProducts'),
          link: true,
          exact: true,
          disabled: false,
          to: {
            name: "FarmProducts",
            params: { farmId: this.$route.params.farmId },
          },
        },
        {
          text: this.$t('farm.products'),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}
.page-title p {
  color: $primary-color;
}
.border {
  border: 2px solid;
  border-color: #dae1ec;
}
</style>
